<svelte:options
  customElement={{
    tag: 'teo-tpi-dashboard',
    extend: extendWithStyles,
  }}
/>

<script lang="ts">
  import { TPIDashboard } from '@/ui/components/TPIDashboard';
  import { TeoActiveTextProvider } from '@/utils/teo-context';
  import TeoProvider from '@/utils/TeoProvider.svelte';

  import type { TeoCore } from '../teoCore/TeoCore';
  import { extendWithStyles } from './web-component-utils';

  let { teoCore }: { teoCore?: TeoCore } = $props();
</script>

<TeoProvider {teoCore}>
  <TeoActiveTextProvider {teoCore}>
    {#snippet children({ teoText })}
      <TPIDashboard {teoText} />
    {/snippet}
  </TeoActiveTextProvider>
</TeoProvider>
